var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"amount-of-assets-table-cell",on:{"click":() => { _vm.$emit("click") }}},[_vm._v(" "+_vm._s(_vm.item[_vm.category.field])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }